import { TabsProps } from 'antd';
import { StyledTabs } from './TabsStyles';

type ITabsProps = TabsProps;

export type ITab = NonNullable<ITabsProps['items']>[number];

const Tabs = (props: ITabsProps) => <StyledTabs {...props} />;

export default Tabs;
